import { FeatureFlag } from '../FeatureFlag';

export const enableMosaicGridTemplates = new FeatureFlag({
    key: 'enable-mosaic-grid-templates',
    createdOn: '2026-02-26',
    defaultValue: false,
});
